export enum ReportTypeEnum {
  GRID = "GRID",
  PIVOT = "PIVOT",
  EXCEL_SHEET = "EXCEL_SHEET",
}
